import React, { useContext } from "react";
import { Tooltip } from "antd";
import { ReactComponent as PersonSvg } from "../../../assets/icons/person.svg";
import styled from "styled-components";
import { AppContext } from "../../../context";

const CapacityInfoWrapper = styled.div`
  .ahp-all-icon-row {
    display: flex;
    justify-content: center;
    align-items: flex-end;
  }
  .ahp-icon-row {
    display: flex;
    justify-content: center;
  }

  .svg-icon-person {
    display: block-inline;
  }
  .svg-icon-person.adult {
    max-width: 20px;
  }
  .svg-icon-person.child {
    max-width: 14px;
  }
`;

const CapacityInfo = ({ adults, children }) => {
  const info = useContext(AppContext);

  return (
    <>
      <div>{info.t("capacity")}</div>
      <CapacityInfoWrapper>
        <div className="ahp-all-icon-row">
          <Tooltip className="ahp-icon-row" title={info.t("adult")}>
            {[...Array(adults)].map((_, index) => (
              <div style={{ width: 18 }} key={"adults" + index}>
                <PersonSvg className="svg-icon-person adult" />
              </div>
            ))}
          </Tooltip>
          <Tooltip className="ahp-icon-row" title={info.t("child")}>
            {[...Array(children)].map((_, index) => (
              <div style={{ width: 18 }} key={"children" + index}>
                <PersonSvg className="svg-icon-person child" />
              </div>
            ))}
          </Tooltip>
        </div>
      </CapacityInfoWrapper>
    </>
  );
};

export default CapacityInfo;
